import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getHighlightCorrectSummary = (params) => {
	var url = ApiRouters.HIGHLIGHTCORRECTSUMMARY;
	return api.get(url, { params });
};

export const getHighlightCorrectSummaryDetail = (id, params) => {
	var url = `${ApiRouters.HIGHLIGHTCORRECTSUMMARY}/${id}`;
	return api.get(url, { params });
};

export const createQuesHighlightCorrectSummary = (body) => {
	var url = ApiRouters.HIGHLIGHTCORRECTSUMMARY;
	return api.post(url, body);
};

export const updateHighlightCorrectSummaryDetail = (body) => {
	var url = `${ApiRouters.HIGHLIGHTCORRECTSUMMARY}/${body.get('id')}`;
	return api.put(url, body);
};

export const deleteHighlightCorrectSummary = (id) => {
	var url = `${ApiRouters.HIGHLIGHTCORRECTSUMMARY}/${id}`;
	return api.delete(url);
};
